export const textOptions = {
  private: 'This assessment was saved as a private template.',
  org: 'This assessment was saved as a template for your school / organization.',
  public: 'This assessment was saved as a template for public usage.'
};

export const linkOptions = { private: 'View my templates', org: 'View school templates', public: 'View Templates' };
